class CPCPrompt {
  constructor(callback, data1) {
    /**
     * Constructor for CPC Prompt
     * JS Plugin. We can provide information and Initiate
     * the plugin here
     */
    this.body = document.getElementsByTagName("body")[0];
  
    //if callback function is passed assign that
    //to callback or else assigns empty function to it
    this.callback = typeof callback === "function" ? callback : function () {};
    this.data = {};
    this.data1 = data1;
    this.browserCookie = {};
  }
  checkExist(cookie,pref){
    for(let key of cookie){
      if(key.preference_name === pref){
        return key.opted
      }
    }
    return false;
  }
  getPreferences(preference) {
    /**
     * template string to generate
     * preference DOM element
     * for the given preference object
     */
    let browserCookie = atob(this.getCookie('cname'));
   
    //browserCookie = browserCookie ? atob(JSON.parse(browserCookie)) : [preference];
    browserCookie = browserCookie ? JSON.parse(browserCookie) : [preference];
    
    return `
          <div class="cpc-modal-card">
            <label class="cpc-modal-switch">
              <input name="${preference.preference_name}" type="checkbox" ${
                this.checkExist(browserCookie,preference.preference_name) == true ||
                preference.mandatory == true
                ? "checked"
                : ""
                }
              ${preference.mandatory == true ? "disabled" : ""} />
              <span class="cpc-modal-switch-handle"></span>
            </label>
            <h5 class="cpc-modal-card-head">${
            preference.preference_name
            }</h5>
            <p class="cpc-modal-card-content">${preference.description}</p>
            </div>
            `;
  }
 getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  modalHtml() {
    /**
     * Responsible for generating the base HTML Element
     * for the modal popup that is shown in the browser
     * this uses 'data' from self instance
     */

    return `
      <div class="cpc-modal-dialog">
        <div class="cpc-modal-content">
          <div class="cpc-modal-header">
            <h5 class="cpc-modal-title">${this.data.title}</h5>
          </div>
          <div class="cpc-modal-body">
          <p class="cpc-modal-desc">${this.data.sub_title}</p>
            
            ${this.data.category_client
            .map((category, index) =>
              {
                return `
                <div class="cpc-modal-card">
                  ${category.preference_category.map(preference => this.getPreferences(preference)).reduce((accum, current) => accum + current)}
                </div>
                `;
              }  
            )
            .reduce((accum, current) => {accum + current})}
          </div>
          <div class="cpc-modal-footer">
            <button type="button" class="cpc-modal-btn-primary">Save & Continue</button>
          </div>
        </div>
      </div>
  `;
  }

  addEvents(elements, method, event = "click") {
    /**
     * Will create provided event listeners to the
     * given array of elements, method will be a callback
     * when an event occurs, by default event will be click
     */
    if (!(Symbol.iterator in Object(elements))) {
      //if the element is not an array
      elements.addEventListener(event, method);
      return

    }
    for (let item of elements) {
      //elements are array
      item.addEventListener(event, method);
    }
  }
  
  fetchData() {
    return (
      fetch(
        `/value.json`,
      )
      //resolving the promise
      .then(res => res.json())
      .catch(err => {
        /**
         * Exception in Network call can be captured here
         */
        console.log(err);
      })
    );
  }

  initialize(force = false) {
    /* TODO: need to change this to get from cookie instead of network */

    /**
     * Responsible for starting the network call
     * will recieve the data from API and
     * stores it in this instance as 'this.data'
     */
    
    //this.fetchData().then(response => {
      /**
       * Called Once the GET request recieves
       * successful response from the API
       */

      //store the response in data
      //console.log('response', response)
      //this.data = response.client;
      this.data = this.data1.client;

      //display floating bar
      let browserCookie = atob(this.getCookie('cname'));
      if(!force && browserCookie){
        this.callback((status = "POSTED"), JSON.parse(browserCookie));
      }
      else{
        this.showFloatOption();
      }
      //shows the concern window to get concern
      //this.showPopup();
   // });
  }
  floatHtml() {
    /**
     * Responsible for generating the base HTML Element
     * for the float helper that is shown in the browser
     * this uses 'data' from self instance
     */
    return `
      <div class="cpc-float-bg">
        <div class="cpc-float-modal">
          <div class="cpc-float-popover">
            <div class="cpc-float-description">
              ${this.data.description}
            </div>
            <div class="cpc-float-footer">
              <button type="button" class="cpc-modal-btn-primary cpc-cta-accept">Continue</button>
              <button type="button" class="cpc-modal-btn-secondary cpc-cta-configure">Manage cookies</button>
            </div>
          </div>
        </div>
      </div>
    `
  }
  openFloat(e) {
    let openFloat = this.body.getElementsByClassName("cpc-float")[0];
    if (openFloat.classList.contains("open")) {
      openFloat.classList.remove("open")
    } else {
      openFloat.classList.add("open")
    }
  }

  showFloatOption() {
    if(document.querySelector('.cpc-float')){
      return
    }
    this.floatElement = document.createElement("DIV");
    this.floatElement.id = `float-${this.data.clientId}`;
    this.floatElement.innerHTML = this.floatHtml();
    this.floatElement.classList.add("cpc-float");
    this.floatElement.classList.add("open");
    this.body.appendChild(this.floatElement);

    var primaryButton = document.getElementsByClassName("cpc-float-link");
    this.addEvents(primaryButton, this.openFloat.bind(this));
    //this.addEvents(this.floatElement, this.openFloat.bind(this));
    //let manageCookie = document.getElementsByClassName("cpc-manage-cookie");
    //this.addEvents(manageCookie, this.showPopup.bind(this));

    let configure = document.querySelectorAll(".cpc-cta-configure");
    this.addEvents(configure, this.showPopup.bind(this));

    let acceptAll = document.querySelectorAll(".cpc-cta-accept");
    this.addEvents(acceptAll, this.collectAllPreferences.bind(this));
  }

  getSimplifiedData(data) {
    var simplified_data = {};
    data.category_client.forEach(category => {
      simplified_data[
        category.category_name
      ] = category.preference_category.map(preference => {
        return {
          preference_name: preference.preference_name,
          opted: preference.opted
        };
      });
    });

    return simplified_data;
  }


  showPopup() {
    /**
     * Renders the modal window from this.data
     * received from the API and inject to the DOM
     */
    //this.openFloat();
    //to close the cookie popup (firstone)
    let openFloat = this.body.querySelector(".cpc-float");
    openFloat && openFloat.classList.remove("open");

    this.body.classList.add("cpc-modal-open");
    if(document.querySelector('.cpc-modal')){
      return
    }
    this.element = document.createElement("DIV");
    this.element.id = this.data.clientId;
    this.element.innerHTML = this.modalHtml();
    this.element.classList.add("cpc-modal");
    this.body.appendChild(this.element);
    //add event listener to primary button
    //to capture final submit request from the user
    var primaryButton = this.element.getElementsByClassName(
      "cpc-modal-btn-primary"
    );
    this.addEvents(primaryButton, this.collectPreferences.bind(this));

  }
  removePopup() {
    /**
     * Removes the modal window from DOM
     */

    this.body.classList.remove("cpc-modal-open");
    if (this.element !== undefined)
      this.element.parentElement.removeChild(this.element);
  }

  collectPreferences() {
    //get all input elements(assuming all are concents)
    var preferences = document
      .getElementById(this.data.clientId)
      .getElementsByTagName("input");
    var preferencesData = [];
    //create a preference list with the opted concern
    for (let item of preferences) {
      // console.log('item',item.name);
      // console.log('item_opt',item.checked);
      //if (item.classList.contains("cpc-cat-switch")) continue;
      preferencesData.push({
        preference_name: item.name,
        opted: item.checked ? true : false
      });
    }
    this.postData(preferencesData);
    
  }

  collectAllPreferences() {
    let preferencesData = [];

    this.data.category_client.map((category, index) => {
      category.preference_category.map(preference => {
        preferencesData.push({
          preference_name: preference.preference_name,
          opted: true
        })
      });
    });
    this.openFloat();
    this.postData(preferencesData);
  }

  postData(preferencesData) {
    /**
     * collects the final concern from the user
     * and post it to the API
     */
    //generate postdata
    var postData = { 
      visitor_id: this.public_identifier,
      client: this.client_key,
      preferences: preferencesData
    };
    //console.log('Selected Data',preferencesData);
    var d = new Date();
    d.setTime(d.getTime() + (365*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    
    //document.cookie = "cname" + "=" + JSON.stringify(preferencesData) + ";" + expires + ";path=/;SameSite=Strict" ;
    document.cookie = "cname" + "=" + btoa(JSON.stringify(preferencesData)) + ";" + expires + ";path=/;SameSite=Strict" ;
    this.callback((status = "POSTED"), preferencesData);
    this.removePopup();
  }
}

//assigning the class to window object
//to make this accessible public
window.CPCPrompt = CPCPrompt;